import { ACTION_TYPE } from "../actions/actionTypes";

const { FATCA_CRS } = ACTION_TYPE;

const fatcaCrsReducer = (state = {}, action) => {
  switch (action.type) {
    case FATCA_CRS.UPDATE_FATCA:
      const newFatca = { ...state.fatca };
      newFatca[action.payload.name] = action.payload.value;
      return { ...state, fatca: newFatca };
    case FATCA_CRS.CLEAR_FATCA_DATA_EXCEPT_Q1:
      return {
        ...state,
        fatca: {
          ...state.fatca,
          fatcaQ2: "",
          fatcaQ2state: "",
          fatcaQ2city: "",
          fatcaQ3: "",
          fatcaQ3address: "",
          fatcaQ3usPhone: "",
          fatcaQ4: "",
          fatcaQ4address: "",
          fatcaQ5: "",
          fatcaQ5beneficiary: "",
          fatcaQ5nationality: "",
          fatcaQ6: "",
          fatcaQ6name: "",
          fatcaQ6nationality: "",
          fatcaQ6address: "",
          fatcaQ6usPhone: "",
        },
      };
    case FATCA_CRS.AUTO_UPDATE_FATCA:
      return {
        ...state,
        fatca: {
          ...state.fatca,
          fatcaQ1: "no",
          fatcaQ2: "no",
          fatcaQ3: "no",
          fatcaQ4: "no",
          fatcaQ5: "no",
          fatcaQ6: "no",
        },
      };

    case FATCA_CRS.UPDATE_CRS:
      const newCrs = { ...state.crs };
      newCrs[action.payload.name] = action.payload.value;
      return { ...state, crs: newCrs };

    case FATCA_CRS.FETCH_FATCA_CRS:
      return {
        ...state,
        fatca: action.payload.fatca,
        crs: action.payload.crs,
        countryTax: action.payload.countryTax,
      };

    case FATCA_CRS.UPDATE_TAX_LIST:
      return { ...state, countryTax: action.payload };
    default:
      return state;
  }
};

export default fatcaCrsReducer;
